// One route policy for menus, breadcrumbs, category filters and old bookmarks.
// Native fixed URLs are used only when Liquid exposes an existing compatible Shopify Page.
(() => {
  const categoryKeys=['poker-sets','poker-chips','tables-chairs','poker-supplies'];
  const pageKeys={'poker-sets':'categorySets','poker-chips':'categoryChips','tables-chairs':'categoryTables','poker-supplies':'categorySupplies'};
  const normaliseSubcategory=(category,value)=>category==='poker-sets'&&value==='player'?'venue':String(value||'');
  const valid=(category,sub)=>categoryKeys.includes(category)&&(!sub||window.CoolstarCategories?.categories?.[category]?.filters.some(row=>row[0]===sub));
  const localise=raw=>{
    const dest=new URL(raw,location.origin),root=new URL(window.CoolstarShopifyTheme?.routes?.root||'/',location.origin);
    const prefix=root.pathname.replace(/\/$/,'');
    if(dest.origin===location.origin&&prefix&&dest.pathname.startsWith('/pages/')&&!dest.pathname.startsWith(prefix+'/'))dest.pathname=prefix+dest.pathname;
    return dest.origin===location.origin?dest.pathname+dest.search+dest.hash:dest.href;
  };
  const url=(category,value='')=>{
    const sub=normaliseSubcategory(category,value);
    if(!valid(category,sub))return null;
    const native=window.CoolstarShopifyTheme?.routes;
    if(!native)return category+(sub?'-'+sub:'')+'.html';
    const handle=category+(sub?'-'+sub:'');
    if(native.categoryPages?.[handle])return localise(native.categoryPages[handle]);
    const root=String(native.root||'/').replace(/\/?$/,'/');
    const parent=native.categoryPages?.[category]||native.pages?.[pageKeys[category]]||root+'?view='+category;
    const dest=new URL(localise(parent),location.origin);
    if(sub)dest.searchParams.set('subcategory',sub);
    return dest.pathname+dest.search+dest.hash;
  };
  const identify=raw=>{
    let parsed;try{parsed=new URL(raw,location.href);}catch{return null;}
    if(parsed.origin!==location.origin)return null;
    let filename;try{filename=decodeURIComponent(parsed.pathname.split('/').pop()||'');}catch{return null;}
    const slug=filename.endsWith('.html')?filename.slice(0,-5):parsed.pathname.includes('/pages/')?filename:'';
    let category=categoryKeys.find(key=>slug===key||slug.startsWith(key+'-'));
    let sub=category?slug.slice(category.length).replace(/^-/,''):'';
    if(!category){category=parsed.searchParams.get('view');sub=parsed.searchParams.get('subcategory')||'';}
    else if(!sub)sub=parsed.searchParams.get('subcategory')||'';
    sub=normaliseSubcategory(category,sub);
    if(!valid(category,sub))return null;
    return{category,subcategory:sub,handle:category+(sub?'-'+sub:'')};
  };
  const rewrite=raw=>{
    if(!raw||raw.startsWith('#')||/^(?:mailto:|tel:|javascript:|data:)/i.test(raw))return raw;
    const identity=identify(raw);if(!identity)return raw;
    const target=url(identity.category,identity.subcategory);if(!target)return raw;
    const parsed=new URL(raw,location.href),destination=new URL(target,location.href);
    // Preserve filters and campaign/editor parameters. Route identity comes from the validated handle.
    for(const [key,value] of parsed.searchParams)if(key!=='view'&&key!=='subcategory')destination.searchParams.append(key,value);
    destination.hash=parsed.hash;
    return window.CoolstarShopifyTheme?destination.pathname+destination.search+destination.hash:target+destination.search+destination.hash;
  };
  const upgradeCurrent=()=>{
    if(!window.CoolstarShopifyTheme)return false;
    const identity=identify(location.href);if(!identity)return false;
    const next=rewrite(location.href),dest=new URL(next,location.origin);
    if(dest.searchParams.has('view')||dest.searchParams.has('subcategory'))return false;
    const current=location.pathname+location.search+location.hash;
    if(next===current)return false;
    location.replace(next);return true;
  };
  window.CoolstarCategoryRoutes={url,rewrite,identify,normaliseSubcategory,upgradeCurrent};
})();
